import React from "react";
import { Option } from '../Option/Option';
import { OptionInterface } from "../../../domain/interfaces";
import styles from "./Select.module.css";

// Heredamos todos los atributos estándar de un select HTML
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  isInvalid?: boolean;
  options?: OptionInterface[];
}

export const Select: React.FC<SelectProps> = ({
  isInvalid = false,
  options = [],
  ...props
}) => {
  const selectClasses = `${styles.select} ${isInvalid ? styles.invalid : ""}`;

  return (
    <select className={selectClasses} {...props}>
      {options.map((option: OptionInterface) => (
        <Option value={option.id} label={option.name} />
      ))}
    </select>
  );
};
